var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKetsjersportsanlae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.209,3.152a2.574,2.574,0,0,0-2.169-.69A3.9,3.9,0,0,0,7.766,3.608a3.29,3.29,0,0,0-.673,4.175L4.448,10.427l-.086-.086L2.693,12.009l.691.691,1.669-1.669-.086-.086L7.611,8.3a2.575,2.575,0,0,0,1.5.459A3.818,3.818,0,0,0,11.751,7.6C13.1,6.244,13.308,4.251,12.209,3.152ZM8.367,5.49l.589.563-.493.5-.59-.563Zm-.855.155L7.43,5.567a3.066,3.066,0,0,1,.292-.693l.284.271ZM11.83,3.852a1.756,1.756,0,0,1,.33.827l-.056.057-.59-.564Zm-1.266-.588.07-.071a1.771,1.771,0,0,1,.844.306l-.324.329Zm.239.918-.573.581L9.64,4.2l.574-.581Zm-.95-.907-.573.58L9,3.586a3,3,0,0,1,.833-.333ZM9.29,4.554l.59.564L9.307,5.7l-.59-.564ZM9.317,6.4l.59.563-.494.5L8.823,6.9Zm-.844.854.59.564-.193.2A1.766,1.766,0,0,1,8.033,7.7Zm1.3.554.493-.5.3.284a3.183,3.183,0,0,1-.682.319Zm.483-1.2-.59-.564.573-.581.59.564Zm.333-1.5.574-.58.59.564-.573.58Zm1.524.328.014.013a2.97,2.97,0,0,1-.306.836l-.281-.268ZM8.578,3.874l.352.336-.574.581L8,4.454a3.413,3.413,0,0,1,.28-.327A3.673,3.673,0,0,1,8.578,3.874ZM7.352,6.517l.171-.173.589.564-.434.44A1.755,1.755,0,0,1,7.352,6.517Zm3.626.778-.361-.344.574-.581.356.34a3.7,3.7,0,0,1-.314.367C11.152,7.158,11.064,7.224,10.978,7.3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKetsjersportsanlae);
export default __webpack_public_path__ + "static/media/KETSJERSPORTSANLAE.d807f21707509aa0e0f5d4abdcb065de.svg";
export { ForwardRef as ReactComponent };